module.exports = __webpack_public_path__ + "assets/img/1587610637473.06431a81.jpg";